import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import {Validators, FormBuilder, FormGroup} from '@angular/forms';

import {TimeValidators} from '@shared';

import {TravelTimeImprovementSuggestionView} from '../models/travel-time-improvement-suggestion-view.model';

@Component({
    selector: 'app-travel-time-improvement-suggestion-edit',
    templateUrl: './travel-time-improvement-suggestion-edit.component.html',
    standalone: false
})
export class TravelTimeImprovementSuggestionEditComponent implements OnInit {
    private readonly formBuilder = inject(FormBuilder);

    @Input() public suggestion: TravelTimeImprovementSuggestionView;
    @Input() public firstColumnVisible: boolean;
    public suggestionForm: FormGroup;

    @Output() public editing = new EventEmitter<boolean>();

    ngOnInit(): void {
        this.suggestionForm = this.initTimeWindowSuggestionForm();
    }

    public clickedOutside(event: Event): void {
        if (this.suggestionForm.dirty) {
            this.save(event);
        } else {
            this.suggestion.editing = false;
            this.editing.emit(false);
        }
    }

    public save(event: Event): void {
        event.stopPropagation();
        if (this.suggestionForm.pristine || this.suggestionForm.invalid) {
            return;
        }

        this.suggestion.proposedStartTime = this.suggestionForm.value.fromTime;
        this.suggestion.proposedEndTime = this.suggestionForm.value.toTime;
        this.suggestion.permanent = this.suggestionForm.value.permanent;

        this.suggestion.edited = true;
        this.suggestion.editing = false;
        this.editing.emit(false);
    }

    public revert(event: Event): void {
        event.stopPropagation();

        if (this.suggestionForm.dirty || this.suggestion.edited) {
            this.suggestionForm.controls.fromTime.patchValue(this.suggestion.originalProposedStartTime);
            this.suggestionForm.controls.toTime.patchValue(this.suggestion.originalProposedEndTime);
            this.suggestionForm.controls.permanent.patchValue(true);
            this.suggestionForm.markAsPristine();

            this.suggestion.proposedStartTime = this.suggestion.originalProposedStartTime;
            this.suggestion.proposedEndTime = this.suggestion.originalProposedEndTime;
            this.suggestion.permanent = true;
            this.suggestion.edited = false;

            this.timeChanged();
        }
    }

    public timeChanged(): void {
        this.suggestion.newTimeWindowSmaller =
            this.suggestionForm.value.fromTime > this.suggestion.originalProposedStartTime ||
            this.suggestionForm.value.toTime < this.suggestion.originalProposedEndTime;
    }

    private initTimeWindowSuggestionForm(): FormGroup {
        return this.formBuilder.group({
            fromTime: [
                this.suggestion.proposedStartTime,
                Validators.compose([
                    Validators.required,
                    TimeValidators.timeGreaterThan(this.suggestion.originalStartTime)
                ])
            ],
            toTime: [
                this.suggestion.proposedEndTime,
                Validators.compose([Validators.required, TimeValidators.timeLessThan(this.suggestion.originalEndTime)])
            ],
            permanent: [this.suggestion.permanent, Validators.required],
            checked: [this.suggestion.checked]
        });
    }
}
